export const queryKeys = {
  chat: {
    all: ['chat'] as const,
    lists: () => [...queryKeys.chat.all, 'list'] as const,
    history: (groupId: string) =>
      [...queryKeys.chat.all, 'history', groupId] as const,
    messages: (groupId: string) =>
      [...queryKeys.chat.all, 'messages', groupId] as const,
    response: (groupId: string, messageId?: string) =>
      [
        ...queryKeys.chat.all,
        'response',
        groupId,
        ...(messageId ? [messageId] : []),
      ] as const,
  },
  groups: {
    all: ['groups'] as const,
    lists: () => [...queryKeys.groups.all, 'list'] as const,
    detail: (groupId: string) =>
      [...queryKeys.groups.all, 'detail', groupId] as const,
    messages: (groupId: string) =>
      [...queryKeys.groups.all, 'messages', groupId] as const,
  },
  wahaSessions: {
    all: ['waha-sessions'] as const,
    lists: () => [...queryKeys.wahaSessions.all, 'list'] as const,
    detail: () => [...queryKeys.wahaSessions.all, 'detail'] as const,
    deletion: (jobId: string) =>
      [...queryKeys.wahaSessions.all, 'deletion', jobId] as const,
  },
  notes: {
    all: ['notes'] as const,
    byGroup: (groupId: string) =>
      [...queryKeys.notes.all, 'group', groupId] as const,
    byDmContact: (dmContactId: string) =>
      [...queryKeys.notes.all, 'dm', dmContactId] as const,
  },
};
